import { render, staticRenderFns } from "./createAppls.vue?vue&type=template&id=64861f4b&"
import script from "./createAppls.vue?vue&type=script&lang=js&"
export * from "./createAppls.vue?vue&type=script&lang=js&"
import style0 from "./createAppls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports